import { Alert } from "../Alert/Alert";
import CircularProgress from "@mui/material/CircularProgress";
import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import { useCognitoAuth } from "./CognitoAuthProvider";

interface CognitoCallbackProps {
  redirectPath?: string;
}

export const CognitoCallback: React.FC<CognitoCallbackProps> = ({
  redirectPath = "/",
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { handleCallback } = useCognitoAuth();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const processCallback = async () => {
      const params = new URLSearchParams(location.search);
      const code = params.get("code");
      const errorParam = params.get("error");

      if (errorParam) {
        setError(`Authentication failed: ${errorParam}`);
        return;
      }

      if (!code) {
        setError("No authorization code received");
        return;
      }

      const state = params.get("state");
      if (!state) {
        setError("No state parameter received");
        return;
      }

      try {
        await handleCallback(code, state);
        navigate(redirectPath);
      } catch (err) {
        console.error("Callback processing failed", err);
        setError(
          err instanceof Error ? err.message : "Failed to complete authentication"
        );
      }
    };

    processCallback();
  }, [location.search, handleCallback, navigate, redirectPath]);

  if (error) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
        }}
      >
        <Alert
          message="Authentication Error"
          description={error}
          type="error"
          showIcon
        />
      </div>
    );
  }

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
      }}
    >
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 12 }}>
        <CircularProgress size={40} />
        <span>Completing sign in...</span>
      </div>
    </div>
  );
};
